import moment from "moment";
import {
  DB_DATE_FORMAT,
  DISPLAY_DATE_FORMAT,
  TIMEZONE_OFFSET,
} from "../../constants";

/**
 * Whether a reservation's date (the Order's "YYYY-MM-DD" order_date) is still
 * ahead of today in Philippine Time. Mirrors the api's own check on
 * /reservation/:id/move/accepted and /admin/v2/reservations/:id/seat —
 * seating early on the same day, or late for an overdue booking, stays allowed.
 *
 * @param {string} [orderDate] - "YYYY-MM-DD"
 * @param {Date} [now]
 * @returns {boolean}
 */
export const isFutureReservationDate = (orderDate, now = new Date()) => {
  if (!orderDate) return false;
  const today = moment(now).utcOffset(TIMEZONE_OFFSET).format(DB_DATE_FORMAT);
  return orderDate > today;
};

/**
 * Why a reservation can't be seated or finished yet, for the alert prompt —
 * or null when allowed.
 *
 * @param {{order_date?: string}} reservation
 * @param {'seated'|'finished'|Date} [actionOrNow='seated']
 * @param {Date} [now=new Date()]
 * @returns {string|null}
 */
export const getSeatingBlockedReason = (
  reservation,
  actionOrNow = "seated",
  now = new Date(),
) => {
  const action = typeof actionOrNow === "string" ? actionOrNow : "seated";
  const effectiveNow = actionOrNow instanceof Date ? actionOrNow : now;

  const orderDate = reservation?.order_date;
  if (!isFutureReservationDate(orderDate, effectiveNow)) return null;
  const displayDate = moment(orderDate, DB_DATE_FORMAT).format(
    DISPLAY_DATE_FORMAT,
  );
  const subject = action === "finished" ? "Reservations" : "Guests";
  return `This reservation is for ${displayDate}. ${subject} can only be ${action} on the day of their reservation.`;
};
